import SVGIcon, { ICON_LIST, SVGIconProps } from './SVGIcon';

export { ICON_LIST };
export type { SVGIconProps };
export default SVGIcon;
